import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { IntercomModule } from '@y42/intercom';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { AngularSplitModule } from 'angular-split';
import { GitDiffTreeModule } from '../../git-diff-tree';
import { GitUiDisplayModule } from '../../git-ui-display';
import { GitCommitPreviewComponent } from './git-commit-preview.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularSplitModule,
    IntercomModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatTooltipModule,
    FontAwesomeModule,
    MonacoEditorModule,
    GitUiDisplayModule,
    GitDiffTreeModule,
    MatTooltipTruncateModule,
  ],
  declarations: [GitCommitPreviewComponent],
  exports: [GitCommitPreviewComponent],
})
export class GitCommitPreviewModule {}
